import * as yup from 'yup';

export const schema = yup.object({
  photo: yup.string().required('Your photo is required.'),
});

export const INIT_FORM = {
  photo: '',
};
